<div class="flex flex-row flex-wrap box-border justify-start items-center content-center">
  <mat-form-field appearance="outline" class="input-form-select box-border grow shrink basis-full max-w-30% md:max-w-full">
    <mat-label>業種種別</mat-label>
    <mat-select formControlName="systemCode" required>
      <mat-option value="" selected></mat-option>
      <mat-option *ngFor="let type of systemCodeList" [value]="type.value">{{type.viewValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="input-form-select box-border grow shrink basis-full max-w-30% md:max-w-full">
    <mat-label>ファイル種別</mat-label>
    <mat-select formControlName="fileCategory" required>
      <mat-option value="" selected></mat-option>
      <mat-option *ngFor="let type of fileCategoryList" [value]="type.value">{{type.viewValue}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div fxLayout="row wrap" fxLayoutAlign="end center">
  <mat-card-actions class="btn_area_right">
    <button type="button" [disabled]="parentForm.invalid || disableSearch" mat-raised-button color="primary" 
        class="btn" (click)="onClickSearch()">検索</button>
  </mat-card-actions>
  <mat-card-actions class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">クリア</button>
  </mat-card-actions>
</div>
